<template>
  <div class="modal_wrapper">
    <div class="modal_window white_box">
      <div class="modal-header">
        <div>
          <h3
            v-if="stepHeading !== null"
            class="heading"
          >
            {{ stepHeading }}
          </h3>
        </div>

        <slot
          name="header"
          :current-step="currentStep"
        />

        <button
          class="close_modal close_btn"
          :disabled="closeDisabled"
          @click="$emit('closed')"
        >
          <svg-vue icon="icons/modal_cross" />
        </button>
      </div>

      <accordion-transition>
        <div
          v-if="error"
          class="error"
        >
          {{ errorMessage }}
        </div>
      </accordion-transition>

      <component
        :is="currentStep.component"
        v-if="!(currentStep.hidden && currentStep.hidden())"
      />

      <div class="modal-footer">
        <div class="steps">
          <div
            v-for="(step, index) in activeSteps"
            :key="index"
            class="step_item"
            :class="{current: currentStep.name === step.name}"
          >
            <i>{{ index + 1 }}</i>
            <span>{{ step.label }}</span>
          </div>
        </div>

        <slot
          name="footer"
          :current-step="currentStep"
        />

        <div class="buttons">
          <button
            v-for="(button, index) in currentStepButtons"
            :key="index"
            class="btn btn_md"
            :class="button.class || ''"
            :disabled="button.disabled && button.disabled()"
            @click="button.action()"
          >
            <i
              v-if="button.loading && button.loading()"
              class="fas fa-spinner fa-spin"
            />
            {{ button.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionTransition from "../../../../views/reports/components/global/transitions/AccordionTransition.vue";

export default {
  components: {
    AccordionTransition
  },
  props: {
    currentStep: {
      type: Object,
      default: () => {},
    },
    errorMessage: {
      type: String,
      default: 'An error occurred, please try again or contact support.',
    },
    closeDisabled: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['closed'],
  data() {
    return {
      error: null,
    }
  },
  computed: {
    stepHeading() {
      return this.currentStep?.title;
    },
    activeSteps() {
      return this.steps.filter((step) => !(step.hidden && step.hidden()));
    },
    currentStepButtons() {
      return this.currentStep?.buttons?.filter(button => button.visible ? button.visible() : true);
    },
  }
}
</script>

<style lang="scss" scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 5vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);

  &::-webkit-scrollbar {
    width: 0;
  }

  .modal_window {
    position: relative;
    margin: auto;
    max-width: 900px;
    width: 90vw;
    z-index: 100;
    -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
    box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
    border-radius: .75rem;
  }
}

.error {
  background-color: #CC444B;
  color: #FFFFFF;
  border-radius: 0.5rem;
  padding: 0 0.5rem;
  transition: .3s;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0;
  border: none;

  .heading {
    font-weight: 700;
    line-height: 1.42;
    letter-spacing: -0.042em;
    color: #040707;
    font-size: 1.5rem;
  }

  .close_btn {
    width: 32px;
    height: 32px;
    padding: 0;
  }
}

.modal-footer {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 0;
  border: none;
}

.steps {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;

  .step_item {
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    background-color: #FBFAFA;

    &.current {
      background-color: #F0E9FF;

      i {
        background-color: #8362F9;
      }

      span {
        color: #8362F9;
      }
    }

    &:not(:last-of-type) {
      margin-right: 1rem;
    }

    span {
      color: #E8E5E2;
      font-size: 0.875rem;
    }

    i {
      display: inline-flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      width: 1.25rem;
      height: 1.25rem;
      border-radius: 50%;
      background-color: #E8E5E2;
      color: #fff;
      margin-right: 0.5rem;
      font-size: 0.75em;
      font-style: normal;
    }
  }
}

.buttons .btn {
  height: 42px;
  min-width: 105px;
  padding: 0 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  text-transform: none;

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  i {
    margin-right: 10px;
  }
}
</style>
